import React, { Component } from "react";
import { ToastContainer } from "react-toastify";
import toast from "../helpers/toast";
import Httpconfig from "../helpers/HttpconfigRetailer";
import Constant from "../../constants";
import { Multiselect } from "multiselect-react-dropdown";
import { Link } from "react-router-dom";
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";
import RetailerCss from "../../public/css/retailer/retailer_style.css";
import RetailerHeader from "../retailer/RetailerHeader";
import RetailerSideMenu from "../retailer/RetailerSideMenu";
import Footer from "../patient/Patientfooter";
import * as SecureLS from "secure-ls";
import constants from "../../constants";
var ls = new SecureLS({
  encodingType: "aes",
  encryptionSecret: "medleymed",
});
const moment = require("moment");

export default class RetailerCategories extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fields: {},
      errors: {},
      category_images: [],
      status: true,
      productsSearch: "",
      productsResults: [],
      selectedProductIds: [],
      retailerId: "", // should be set from SecureLS or props
    };
  }

  //  Set setting the start tinme
  setStartTimeOnChange = (value) => {
    this.setState({ start_date: value });
  };

  //  for setting the end time
  setEndTimeOnChange = (value) => {
    this.setState({ end_date: value });
  };

  // To get detais after first render
  componentDidMount = () => {
    const { handle } = this.props.match.params;
    let userData = ls.get("retuserObj");
    if (userData) {
      if (userData != "") {
        this.setState({
          retailerId: userData.retailer_id,
        });
        this.forceUpdate();
      }
    } else {
      window.location.href = "/retailer/login";
    }

    if (handle) this.getCategoryInfo(handle);
  };

  // For getting the users data

  //  For on select

  onSelect = (selectedListdata, selectedItem) => {
    this.setState({
      selectedList: selectedListdata.map((x) => x.id),
    });
  };

  //  For on remove
  onRemove = (deselectedList, removedItem) => {
    this.setState({
      selectedList: deselectedList.map((x) => x.id),
    });
  };

  // When value changes of the fields
  handleValidation() {
    let fields = this.state.fields;
    let errors = {};
    let formIsValid = true;

    // Validate category_name (mandatory)
    if (!fields["category_name"]) {
      formIsValid = false;
      errors["category_name"] = "Category name cannot be empty";
    } else if (!/^[@ _ a-zA-Z0-9- ]*$/.exec(fields["category_name"])) {
      formIsValid = false;
      errors["category_name"] = "Category name contains invalid characters";
    }

    // Optionally validate category_description (optional or mandatory as you want)
    // if (!fields["category_description"]) {
    //   formIsValid = false;
    //   errors["category_description"] = "Description cannot be empty";
    // }

    this.setState({ errors: errors });
    return formIsValid;
  }

  // To get all the ResponderInfo
  getCategoryInfo(category_id) {
    console.log("Fetching category info for ID:", category_id);
    Httpconfig.httptokenpost(
      constants.siteurl + "api/productcategory/getcategorywiseproducts",
      { category_id: category_id }
    ).then((response) => {
      // The response data is an array, so get the first item
      const cat = Array.isArray(response.data.data)
        ? response.data.data[0]
        : response.data.data;
      if (cat) {
        // Prefill selected products from productMaster_b2cs
        let selectedProducts = [];
        let selectedProductIds = [];
        if (Array.isArray(cat.productMaster_b2cs) && cat.productMaster_b2cs.length > 0) {
          selectedProducts = cat.productMaster_b2cs.map(prod => ({
            id: prod.id,
            medicinename: prod.medicinename,
            manufacturer: prod.manufacturer,
            packaging_detail: prod.packaging_detail,
            displayLabel: prod.packaging_detail
              ? `${prod.medicinename} (${prod.packaging_detail})`
              : prod.medicinename,
          }));
          selectedProductIds = selectedProducts.map(prod => prod.id);
        }
        this.setState({
          fields: {
            category_name: cat.category_name,
            category_description: cat.category_description,
          },
          category_images: cat.category_image || [],
          status: cat.status,
          selectedProducts,
          selectedProductIds,
        });
      }
    });
  }

  handleImageUpload = (event) => {
    const files = event.target.files;
    if (!files || files.length === 0) return;
    // Only allow one image
    const file = files[0];
    const reader = new FileReader();
    reader.onloadend = () => {
      this.setState({ category_images: [{ url: reader.result }] });
    };
    reader.readAsDataURL(file);
  };

  handleDeleteImage = (idx) => {
    const newImages = [...this.state.category_images];
    newImages.splice(idx, 1);
    this.setState({ category_images: newImages });
  };

  checkSubmit(event) {
    event.preventDefault();
    const { handle } = this.props.match.params;
    if (this.handleValidation() && handle) {
      this.updateCategory(event);
    } else if (this.handleValidation() && handle == undefined) {
      this.createCategory(event);
    } else {
      toast.warn("Form has errors.");
    }
  }

  // creates new controller
  createCategory = (event) => {
    event.preventDefault();
    const { fields, status, category_images, retailerId } = this.state;

    // Only send new images (base64), ignore any with http URLs
    const images = (category_images || [])
      .filter((img) => img.url && !img.url.startsWith("http"))
      .map((img) => ({ image_url: img.url }));

    const payload = {
      category_name: fields.category_name,
      module_id: fields.module_id || 2,
      category_description: fields.category_description,
      parent_id: fields.parent_id || 1,
      retailer_id: retailerId || 1,
      slug: fields.slug || "Pain relief",
      status: status,
      images: images,
      product_ids: this.state.selectedProductIds,
    };

    Httpconfig.httptokenpost(
      constants.siteurl + "api/productcategory/",
      payload
    )
      .then((response) => {
        console.log("Create category response:", response);
        if (
          response.data &&
          (response.data.message === "Category created successfully" ||
            response.data.message === "Category created successfully with products assigned")
        ) {
          // Handle category_image null case
          const cat = response.data.data;
          this.setState({
            category_images: cat && cat.category_image ? cat.category_image : [],
          });
          toast.success("Category created successfully");
          setTimeout(
            () => this.props.history.push("/retailer/ViewRetailerCategories"),
            1000
          );
        } else {
          toast.error("Failed to create category");
        }
      })
      .catch((error) => {
        toast.error(error.response.data.message || "Error creating category");
      });
  };

  // updates controller
  updateCategory = (event) => {
    event.preventDefault();
    const { handle } = this.props.match.params;
    const { fields, status, category_images, retailerId } = this.state;

    const images = (category_images || []).map((img) => {
      if (img.url && img.url.startsWith("http")) {
        return { image_url: img.url };
      }
      return { image_url: img.url };
    });

    const payload = {
      category_id: handle, // send category id
      category_name: fields.category_name,
      category_description: fields.category_description,
      status: status,
      slug: fields.slug || "pain",
      parent_id: fields.parent_id || "1",
      module_id: fields.module_id || "2",
      retailer_id: retailerId || "1",
      images: images,
      product_ids: this.state.selectedProductIds, // send selected product ids
    };

    Httpconfig.httptokenput(
      constants.siteurl + "api/productcategory/" + handle,
      payload
    )
      .then((response) => {
        if (
          response.data &&
          response.data.message === "Category updated successfully"
        ) {
          toast.success("Category updated successfully");
          setTimeout(
            () => this.props.history.push("/retailer/ViewRetailerCategories"),
            1000
          );
        } else {
          toast.error("Failed to update category");
        }
      })
      .catch((error) => {
        toast.error("Error updating category");
      });
  };

  handleProductsSearchChange = (e) => {
    this.setState({ productsSearch: e.target.value });
  };

  searchProducts = () => {
    const { productsSearch, retailerId } = this.state;
    if (!productsSearch || !retailerId) return;
    Httpconfig.httptokenpost(
      constants.siteurl + "api/OM/MedicineDetails/medicinesearchbyretailerid",
      {
        retailer_id: retailerId,
        medicine_name: productsSearch,
        page: 1,
        limit: 20,
      }
    ).then((response) => {
      // Ensure each product has id and medicinename
      const products = (response.data.result || []).map((prod) => ({
        id: prod.id,
        medicinename: prod.medicinename,
        manufacturer: prod.manufacturer,
        packaging_detail: prod.packaging_detail,
        displayLabel: prod.packaging_detail
          ? `${prod.medicinename} (${prod.packaging_detail})`
          : prod.medicinename,
      }));
      this.setState({ productsResults: products });
    });
  };

  handleProductSelect = (id) => {
    this.setState((prevState) => {
      const alreadySelected = prevState.selectedProductIds.includes(id);
      return {
        selectedProductIds: alreadySelected
          ? prevState.selectedProductIds.filter((pid) => pid !== id)
          : [...prevState.selectedProductIds, id],
      };
    });
  };

  //  For validating the fields

  render() {
    const { fields, errors, coupon_data } = this.state;

    return (
      <main id="main">
        <RetailerHeader />
        <RetailerSideMenu />
        <section
          id="main_dashboard"
          className="col-md-offset-2"
          style={{ marginLeft: "180px" }}
        >
          <div className="container-fluid" id="main_front">
            <div className="row">
              <div className="col-md-10">
                <div className="dash-section">
                  <div className="section-header">
                    <ol className="breadcrumb">
                      <li className="active">
                        <Link to="/admin"> Dashboard</Link> &gt;
                        <a> Categories </a>
                      </li>
                    </ol>
                  </div>
                </div>

                <section id="CMS_tab">
                  <div className="CMS_content create_calender">
                    <div className="container">
                      <div className="row">
                        <div className="tab-header">
                          <h3>
                            {this.props.match.params.handle
                              ? "Update Category Management"
                              : "Create Category Management"}
                          </h3>
                        </div>
                        <div id="reg_form">
                          <form onSubmit={this.checkSubmit.bind(this)}>
                            <div className="offer-manage-regform">
                              <div className="lft-sec">
                                <div className="row">
                                  <div className="col-md-6">
                                    <div className="form-group">
                                      <label>Category Name</label>
                                      <input
                                        type="text"
                                        name="category_name"
                                        value={
                                          this.state.fields.category_name || ""
                                        }
                                        onChange={(e) =>
                                          this.setState({
                                            fields: {
                                              ...this.state.fields,
                                              category_name: e.target.value,
                                            },
                                          })
                                        }
                                        className="form-control"
                                        placeholder="Category Name"
                                      />
                                      <span className="cRed">
                                        {this.state.errors["category_name"]}
                                      </span>
                                    </div>
                                  </div>
                                  <div className="col-md-6">
                                    <div className="form-group">
                                      <label>Description</label>
                                      <textarea
                                        name="category_description"
                                        value={
                                          this.state.fields.category_description ||
                                          ""
                                        }
                                        onChange={(e) =>
                                          this.setState({
                                            fields: {
                                              ...this.state.fields,
                                              category_description: e.target.value,
                                            },
                                          })
                                        }
                                        className="form-control"
                                        placeholder="Category Description"
                                      />
                                      <span className="cRed">
                                        {this.state.errors["category_description"]}
                                      </span>
                                    </div>
                                  </div>
                                  <div className="col-md-6">
                                    <div className="form-group">
                                      <label>Status</label>
                                      <select
                                        value={
                                          this.state.status ? "active" : "inactive"
                                        }
                                        onChange={(e) =>
                                          this.setState({
                                            status: e.target.value === "active",
                                          })
                                        }
                                        className="form-control"
                                      >
                                        <option value="active">Active</option>
                                        <option value="inactive">Inactive</option>
                                      </select>
                                    </div>
                                  </div>
                                  <div className="col-md-6">
                                    <div className="form-group">
                                      <label>Category Images</label>
                                      <input
                                        type="file"
                                        accept="image/*"
                                        className="form-control"
                                        onChange={this.handleImageUpload}
                                      />
                                      <div style={{ display: "flex", gap: "8px" }}>
                                        {this.state.category_images.map((img, idx) => (
                                          <div key={idx} style={{ position: "relative", textAlign: "center" }}>
                                            <img
                                              src={img.url}
                                              alt="Category"
                                              style={{ width: "60px", height: "60px", borderRadius: "6px", objectFit: "cover", border: "1px solid #ccc" }}
                                            />
                                            <button
                                              type="button"
                                              onClick={() => this.handleDeleteImage(idx)}
                                              style={{
                                                position: "absolute",
                                                top: 0,
                                                right: 0,
                                                background: "rgba(255,255,255,0.8)",
                                                border: "none",
                                                borderRadius: "50%",
                                                width: 22,
                                                height: 22,
                                                cursor: "pointer",
                                                color: "#d00",
                                                fontWeight: "bold",
                                                lineHeight: "18px",
                                                padding: 0
                                              }}
                                              title="Remove"
                                            >
                                              ×
                                            </button>
                                            <div style={{ fontSize: 12, marginTop: 2 }}>
                                              {img.name || `Image ${idx + 1}`}
                                            </div>
                                          </div>
                                        ))}
                                      </div>

                                    </div>
                                  </div>

                                </div>
                                <div className="row">
                                  <div className="form-group col-md-12">
                                    <button
                                      type="submit"
                                      className="btn  btn-primary save_btn"
                                    >
                                      Save Category
                                    </button>{" "}
                                    &nbsp;
                                    <Link
                                      to="/retailer/ViewRetailerCategories"
                                      className="cancel_btn"
                                    >
                                      Cancel
                                    </Link>{" "}
                                    &nbsp; &nbsp;
                                  </div>
                                </div>
                              </div>
                              <div className="rt-sec">
                                <div className="row">
                                  <div className="col-md-12">
                                    <div className="form-group">
                                      <label
                                        htmlFor="products"
                                        className="custom-control-label"
                                        style={{
                                          marginBottom: "-3px",
                                          fontWeight: "bold",
                                        }}
                                      >
                                        Products
                                      </label>
                                      <Multiselect
                                        options={this.state.productsResults}
                                        displayValue="displayLabel"
                                        selectedValues={this.state.selectedProducts}
                                        onSelect={(selectedList) => {
                                          this.setState({
                                            selectedProducts: selectedList,
                                            selectedProductIds: selectedList.map(prod => prod.id)
                                          });
                                        }}
                                        onRemove={(selectedList) => {
                                          this.setState({
                                            selectedProducts: selectedList,
                                            selectedProductIds: selectedList.map(prod => prod.id)
                                          });
                                        }}
                                        onSearch={(searchText) => {
                                          this.setState({ productsSearch: searchText }, this.searchProducts);
                                        }}
                                        placeholder="Search & Select Products"
                                        showCheckbox={true}
                                        closeOnSelect={false}
                                        style={{
                                          chips: { background: "#007bff", color: "#fff", fontWeight: "bold" },
                                          multiselectContainer: { color: "#333" },
                                        }}
                                      />

                                      {/* <div
                                        style={{
                                          marginTop: "8px",
                                          minHeight: "24px",
                                        }}
                                      >
                                        {this.state.selectedProducts &&
                                          this.state.selectedProducts.length > 0 &&
                                          this.state.selectedProducts.map(
                                            (prod) => (
                                              <span
                                                key={prod.id}
                                                style={{
                                                  display: "inline-block",
                                                  background: "#007bff",
                                                  color: "#fff",
                                                  borderRadius: "12px",
                                                  padding: "4px 12px",
                                                  marginRight: "6px",
                                                  marginBottom: "4px",
                                                  fontSize: "13px",
                                                }}
                                              >
                                                {prod.medicinename}
                                              </span>
                                            )
                                          )}
                                      </div> */}
                                    </div>
                                  </div>

                                </div>
                              </div>
                            </div>
                          </form>
                        </div>
                        <ToastContainer />
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </section>
      </main>
    );
  }
}
